import styled from 'styled-components/macro';
import { COLORS, TYPOGRAPHY } from 'styleguide';

const Input = styled.input`
  box-sizing: border-box;
  width: 100%;
  height: 40px;
  padding-left: 8px;
  padding-right: 48px;
  border: 1px solid ${COLORS.gray60};
  border-radius: 4px;
  background: transparent;
  ${TYPOGRAPHY.body}
  color: #fff;

  &:disabled {
    opacity: 0.4;
  }

  &::placeholder {
    color: ${COLORS.gray40};
  }
`;

export default Input;
